// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kWdn","rootMobile":"styles_rootMobile__1M51h"};